const communities = {
  'Southview-Park Meadows': 'Southview/Park Meadows',
  'Crestwood-Norwood': 'Crestwood/Norwood',
  'SW Hill': 'South West Hill',
  'SW Southridge': 'South West Southridge',
  'Airport G.P.': 'Airport',
};

/**
 * Manage edge cases.
 *
 * @param {String} community
 * @return {String}
 * @private
 */

const edgeCases = (community) => {
  const result = communities[community];
  if (result) return result;
  if (community.includes(', The')) {
    return `The ${community.replace(', The', '')}`;
  }
  return community;
};

/**
 * Transform community label into something that can be read by human.
 *
 * @param {String} str
 * @return {String}
 * @public
 */

export const transformCommunityLabel = (community) => {
  const replaceCases = { _: '/', 'of,': 'of ' };
  const regex = /_|of,/g;
  return edgeCases(community).replace(regex, (match) => replaceCases[match])
    .trim();
};

export default {
  transformCommunityLabel,
};
